import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Transition as _Transition, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icons/skull.png'
import _imports_1 from '../assets/icons/edit.svg'
import _imports_2 from '../assets/icons/save.svg'
import _imports_3 from '../assets/icons/sign-out.svg'
import _imports_4 from '../assets/icons/coffee.svg'


const _withScopeId = n => (_pushScopeId("data-v-2534353b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex-row padded" }
const _hoisted_3 = { class: "column-1-n-2" }
const _hoisted_4 = { class: "deets-n-stats" }
const _hoisted_5 = { class: "flex-row" }
const _hoisted_6 = { class: "flex-col" }
const _hoisted_7 = { class: "flex-col" }
const _hoisted_8 = { class: "stress-n-trauma" }
const _hoisted_9 = { class: "health" }
const _hoisted_10 = { class: "column-3" }
const _hoisted_11 = { class: "upper-right" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Player: ")
const _hoisted_13 = { class: "plain-text" }
const _hoisted_14 = { class: "skills" }
const _hoisted_15 = { class: "equipment" }
const _hoisted_16 = {
  href: "http://www.ko-fi.com/mothersheet",
  target: "_blank"
}
const _hoisted_17 = {
  key: 0,
  class: "img-button donate-button button",
  src: _imports_4,
  title: "Support"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StarField = _resolveComponent("StarField")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_PersonalDetails = _resolveComponent("PersonalDetails")!
  const _component_Stats = _resolveComponent("Stats")!
  const _component_Saves = _resolveComponent("Saves")!
  const _component_Stress = _resolveComponent("Stress")!
  const _component_TraumaResponse = _resolveComponent("TraumaResponse")!
  const _component_Health = _resolveComponent("Health")!
  const _component_HighScore = _resolveComponent("HighScore")!
  const _component_Skills = _resolveComponent("Skills")!
  const _component_Equipment = _resolveComponent("Equipment")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.dead && !_ctx.editMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            class: _normalizeClass(["death", {'default-pointer': _ctx.dying}]),
            src: _imports_0,
            onClick: _cache[0] || (_cache[0] = () => { if(_ctx.dying === false){_ctx.showDeathModal = true} })
          }, null, 2),
          (_ctx.showStarField)
            ? (_openBlock(), _createBlock(_component_StarField, {
                key: 0,
                "z-index": "101"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "death-mask",
            style: _normalizeStyle({backgroundColor: `rgba(0, 0, 0, ${_ctx.deathMaskOpacity})`})
          }, null, 4)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Modal, {
      visible: _ctx.showDeathModal,
      title: "Is this the end?",
      color: "grey",
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDeathModal = false)),
      zIndex: "104"
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          class: "modal-btn green",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.revive && _ctx.revive(...args)))
        }, "Revive"),
        _createElementVNode("button", {
          class: "modal-btn red",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.farewell && _ctx.farewell(...args)))
        }, "Farewell " + _toDisplayString(_ctx.name), 1)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_PersonalDetails)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Stats),
              _createVNode(_component_Saves),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Stress),
                _createVNode(_component_TraumaResponse)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Health)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.playerName), 1),
          _createVNode(_component_HighScore)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_Skills)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_Equipment)
        ])
      ])
    ]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (!_ctx.editMode && !_ctx.dying)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "img-button edit-button button",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleEditMode && _ctx.toggleEditMode(...args))),
              src: _imports_1,
              title: "Edit Mode"
            }))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: "img-button button",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleEditMode && _ctx.toggleEditMode(...args))),
              src: _imports_2,
              title: "Save"
            }))
      ]),
      _: 1
    }),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (!_ctx.editMode && !_ctx.dying)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "img-button sign-out-button button",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args))),
              src: _imports_3,
              title: "Sign Out"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_Modal, {
      visible: _ctx.showSignOutModal,
      title: "Sign Out?",
      onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showSignOutModal = false)),
      color: "red"
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          class: "modal-btn white",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args)))
        }, "Yes"),
        _createElementVNode("button", {
          class: "modal-btn white",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showSignOutModal = false))
        }, "No")
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _createElementVNode("a", _hoisted_16, [
          (!_ctx.editMode && !_ctx.dying)
            ? (_openBlock(), _createElementBlock("img", _hoisted_17))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ], 64))
}